import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, Signal, signal} from '@angular/core';
import {AdventureService} from './adventure.service';
import {Title} from '@angular/platform-browser';
import {Action} from './action';
import {GameLogicService} from './game-logic.service';
import {InlineActionsPipe} from './inline-actions.pipe';
import { LocalizationService } from './localization-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [InlineActionsPipe],
  standalone: true
})
export class AppComponent implements OnInit {
  placeTitle: string;
  preDesc: string[];
  description: string;
  postDesc: string[];
  actions: Action[];
  actionButtons: Action[];
  enabled: boolean;   // to disable action buttons while animating
  status: Signal<string>;   // status formatted for reading by the player
  restartCaption: Signal<string>;   // button caption on win/lose
  closeButton: boolean;
  languageKey = signal('');
  logicInitialized = signal(false);

  constructor(private adventureService: AdventureService, private title: Title,
              private gameLogicService: GameLogicService, private cdr: ChangeDetectorRef,
              private ls: LocalizationService) {}

  ngOnInit(): void {
    this.gameLogicService.appComponent = this;
    this.adventureService.setOpener(window.opener);
    this.ls.setLocale("hu", this.languageKey);
    this.closeButton = !!window.opener;
    this.adventureService.getAdventureData().subscribe(
      res => {
        console.log("starting game", res);
        this.gameLogicService.start(res);

        // set page title in browser
        this.title.setTitle(this.gameLogicService.title);

        this.enabled = true;
        this.cdr.detectChanges();

        // fade-in animation
        document.body.style.opacity = '1';
      }
    );
  }

  onAction($event: Event, chosenPlace: string): void {
    // fade-out animation
    document.body.style.opacity = '0';
    this.enabled = false;

    // actual place change timed for the end of animation
    setTimeout(() => {
      this.gameLogicService.enter(chosenPlace);

      // fade-in animation
      document.body.style.opacity = '1';
      this.enabled = true;
      this.cdr.detectChanges();
    }, 500);
  }

  restart(): void {
    // fade-out animation
    document.body.style.opacity = '0';
    this.enabled = false;

    // time the start
    setTimeout(() => {
      this.ngOnInit();
      this.cdr.detectChanges();
    }, 1500);
  }

  _(key: string): string {
    return this.ls._(key);
  }

  showTooltip(txt: string): void {
    const tooltip = document.getElementById("tooltip");
    tooltip.style.display = "block";
    tooltip.innerText = txt;
  }

  hideTooltip(): void {
    document.getElementById("tooltip").style.display = "none";
  }
}
